import axios from 'axios';
import {
  api,
  isJSON,
  getUserName as getUsername,
} from '@acilearning/ibl-web-react-common';
import { isExtendedCatalogDisabled } from '../utils/helpers';

export function orgSearch(data, callback) {
  let url = `${getIBLSEARCHURL()}/api/search/search/${data}`;
  axios
    .get(url)
    .then((response) => {
      // Handle successful response
      callback(response.data);
    })
    .catch((error) => {
      // Handle error
      console.error(error);
    });
}

export function getSkillDescription(skillLevel) {
  switch (skillLevel) {
    case 1:
      return 'Can complete narrow and limited tasks requiring basic skills with direct supervision or guidance.';
    case 2:
      return 'Handles routine assignments with some confidence; occasional assistance may be needed.';
    case 3:
      return 'Capable of managing varied tasks; understands nuances but may seek guidance for complexities.';
    case 4:
      return 'Skilled at handling complex scenarios; regularly assists and mentors others in the domain.';
    case 5:
      return 'Demonstrates mastery in tasks, often pioneering solutions; consistently leads by example.';
    default:
      return ''; // Handle invalid skill levels
  }
}

export function getUserId() {
  let userData = JSON.parse(localStorage.getItem('userData'));
  return userData.user_id;
}

export function getUserName() {
  let userData = JSON.parse(localStorage.getItem('userData'));
  return userData?.user_nicename;
}

export function getTenant() {
  // return "main"
  return localStorage.getItem('tenant');
}

export function userIsAdmin() {
  const data = localStorage.getItem('current_tenant');
  if (isJSON(data)) {
    const tenant = JSON.parse(data);
    return tenant?.is_admin;
  } else {
    return false;
  }
}

export function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  var parameterValue = decodeURIComponent(results[2].replace(/\+/g, ' '));
  parameterValue = parameterValue.replace(/ /g, '+'); // Replace spaces with "+"
  return parameterValue;
}

export function credentialImageURL(credential) {
  return credential.credentialDetails.iconImage || '/images/default_badge.png';
}

export function getRandomImage() {
  let img_url = '/images/courses/';
  let images_array = [
    'c1s.jpeg',
    'c2s.jpeg',
    'c3s.jpeg',
    'c4s.jpeg',
    'c5s.jpeg',
    'c6s.jpeg',
    'c7s.jpeg',
    'c8s.jpeg',
  ];
  let random = Math.floor(Math.random() * images_array.length);
  return img_url + images_array[random];
}

export function secondsToDaysHoursAndMinutes(_seconds) {
  const days = Math.floor(_seconds / 86400); // 86400 seconds in a day
  const hours = Math.floor((_seconds % 86400) / 3600);
  const minutes = Math.floor((_seconds % 3600) / 60);
  const seconds = _seconds % 60;

  const formattedHours = hours < 10 ? `0${hours}` : hours;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${days > 0 ? `${days} day${days > 1 ? 's' : ''}, ` : ''}${formattedHours}:${formattedMinutes}`;
}

export function secondsToHoursAndMinutes(_seconds) {
  const hours = Math.floor(_seconds / 3600);
  const minutes = Math.floor((_seconds % 3600) / 60);
  const seconds = _seconds % 60;

  const formattedHours = hours < 10 ? `0${hours}` : hours;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${formattedHours}:${formattedMinutes}`;
}

// TODO : add process.env
export function getIBLSEARCHURL() {
  return process.env.REACT_APP_IBL_SEARCH_URL;
}

export function getYearDateRange() {
  var currentDate = new Date();
  var currentYear = currentDate.getFullYear();
  var currentMonth = currentDate.getMonth();

  var startMonth = (currentMonth + 12) % 12;
  var endMonth = currentMonth;
  var yearOffset = Math.floor((currentMonth - 12) / 12);
  var startYear = currentYear + yearOffset;

  var startDate = new Date(startYear, startMonth, 1);
  var endDate = new Date(currentYear, endMonth + 1, 0);

  return {
    start: startDate.toISOString().split('T')[0],
    end: endDate.toISOString().split('T')[0],
  };
}

export function formatEarnedOnDate(stringDate) {
  let options = { day: 'numeric', year: 'numeric', month: 'short' };
  let date = new Date(stringDate);
  return date.toLocaleDateString('en-US', options);
}

export function getImageUrl(url) {
  const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;

  if (urlRegex.test(url)) {
    return url;
  }

  return '/images/default_avatar.png';
}

export function parseLocalStorageData(key) {
  const jsonString = localStorage.getItem(key);

  if (!jsonString) {
    console.error(`No data found in localStorage for key: ${key}`);
    return null;
  }

  try {
    const parsedData = JSON.parse(jsonString);
    return parsedData;
  } catch (error) {
    console.error(`Error parsing JSON data for key: ${key}`, error);
    return null;
  }
}

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

export const handleLogout = () => {
  api.iblwebauth.logout(
    JSON.stringify({ username: getUsername() }),
    (logoutUrl) => {
      window.location.href = `${logoutUrl}?redirect_to=${process.env.REACT_APP_IBL_SPA_AUTH_URL}/logout?redirect-to=${window.location.origin}/logout&app=skills`;
    }
  );
};

export const getAnalyticsURL = () => {
  return process.env.REACT_APP_IBL_SPA_ANALYTICS_URL || '#';
};

export const isStripeEnabled = () => {
  return process.env.REACT_APP_IBL_ENABLE_STRIPE === 'true';
};

export const isStaticPagesEnabled = () => {
  return process.env.REACT_APP_IBL_STATIC_PAGES_ENABLED === 'true';
};

export const isCustomMenusEnabled = () => {
  return (
    process.env.REACT_APP_IBL_STATIC_PAGES_ENABLED_USE_CUSTOM_MENUS === 'true'
  );
};

export const isCustomFooterMenusEnabled = () => {
  return (
    process.env.REACT_APP_IBL_STATIC_PAGES_ENABLED_USE_CUSTOM_FOOTER_MENUS ===
    'true'
  );
};

export const isCustomSubMenusEnabled = () => {
  return (
    process.env.REACT_APP_IBL_STATIC_PAGES_ENABLED_USE_CUSTOM_HTML_SUBMENUS ===
    'true'
  );
};

export const getLoginURL = () => {
  return `${process.env.REACT_APP_IBL_SPA_AUTH_URL}/login?redirect-to=${window.location.origin}&app=skills`;
};

export const getQueryParamValue = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const value = queryParams.get('q');
  return value === null ? '' : value;
};

export const getTenants = () => {
  let tenants = [];
  try {
    tenants = JSON.parse(localStorage.getItem('tenants'))?.map(
      (tenant) => tenant.key
    );
  } catch {}
  return tenants;
};

export const queryParamsToDict = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const result = {};

  queryParams.forEach((value, key) => {
    if (result[key]) {
      // If the key already exists, convert it to an array (if not already)
      result[key] = Array.isArray(result[key])
        ? [...result[key], value]
        : [result[key], value];
    } else {
      // Otherwise, store it as a string
      result[key] = value;
    }
  });

  return result;
};

export function getFacetItemsAPI(callback) {
  const username = getUsername();

  const queryParams = queryParamsToDict();
  const requestObj = {};
  // const searchQueryValue = getQueryParamValue();
  // if (searchQueryValue) {
  //   requestData['query'] = searchQueryValue;
  // }
  if (queryParams['content']) {
    requestObj['content'] = queryParams['content'];
  }
  if (username) {
    requestObj['username'] = username;
    if (isExtendedCatalogDisabled()) {
      requestObj['tenant'] = getTenant();
    }
    api.ibldmsearch.searchPersonalizedCatalog(requestObj, (data) => {
      callback(data.facets);
    });
  } else {
    api.ibldmsearch.searchCatalog(requestObj, (data) => {
      callback(data.facets);
    });
  }

  // orgSearch(data, (response) => {
  //   callback(response);
  // });
}

export function convertDurationToHHMM(durationString) {
  try {
    // Remove the word "duration" and trim any whitespace
    const cleanedString = durationString.replace('duration', '').trim();

    // Convert the cleaned string to a number
    const durationInSeconds = parseInt(cleanedString, 10);

    // Calculate hours and minutes
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);

    // Format hours and minutes to HH:MM
    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}`;
  } catch (e) {
    console.error('Input string does not contain a valid number of seconds');
    return '00:00';
  }
}

const convertInstructorTerms = (term) => {
  if (term === 'self-paced') {
    return 'self_paced true';
  }

  if (term === 'instructor-led') {
    return 'self_paced false';
  }
  return term;
};

export function getDiscoverItemsAPI(callback, page, selectedFacets, context) {
  const indexes = [
    { _index: 'ibl-dm.public.dl_catalog_app_course' },
    { _index: 'ibl-dm.public.dl_catalog_app_pathway' },
    { _index: 'ibl-dm.public.dl_catalog_app_program' },
  ];

  const indicesParamName =
    selectedFacets?.length > 0 || context
      ? 'multiple_indices_facet_search'
      : 'multiple_indices';

  // Extract only the term values from selectedFacets and ensure uniqueness using a Set
  const facets = new Set(
    Array.isArray(selectedFacets)
      ? selectedFacets.map((facet) => {
          const [facetName, term] = facet.split(':');
          return convertInstructorTerms(term);
        })
      : []
  );

  // Include context if it exists
  if (context) {
    facets.add(context);
  }

  // Convert the Set back to an array for encoding
  const uniqueFacetsArray = Array.from(facets);
  const encodedFacets = uniqueFacetsArray.map((facet) =>
    encodeURIComponent(facet)
  );
  const data = `?${indicesParamName}=${encodeURIComponent(JSON.stringify(indexes))}&page_size=10&page=${page}${encodedFacets.length > 0 ? `&facet_search=${JSON.stringify(encodedFacets)}` : ''}`;

  orgSearch(data, (response) => {
    callback(response);
  });
}

export const processFilterData = (data) => {
  const result = {};

  data.forEach((item) => {
    const [key, value] = item.split(':');
    if (!result[key]) {
      result[key] = [];
    }
    result[key].push(value);
  });

  return result;
};

export const toPascalCaseWithSpaces = (str) => {
  return str
    .toLowerCase()
    .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match) => match.toUpperCase());
};

export function getSkillRatingDescription(skillLevel) {
  switch (skillLevel) {
    case 0:
      return 'NOT RATED';
    case 1:
      return 'BEGINNER';
    case 2:
      return 'NOVICE';
    case 3:
      return 'INTERMEDIATE';
    case 4:
      return 'ADVANCED';
    case 5:
      return 'EXPERT';
    default:
      return ''; // Handle invalid skill levels
  }
}

export function getRoles(callback, page, selectedFacets, context) {
  /*const index = { _index: 'ibl-dm.public.dl_catalog_app_role' };

  const data = `?filter=${JSON.stringify(index)}&page=${page}${context ? '&context=' + context : ''}`;

  orgSearch(data, (response) => {
    callback(response);
  });*/
  //Search Endpoint updated

  const queryParam = new URLSearchParams({
    content: 'roles',
    ...(context
      ? {
          query: context,
        }
      : {}),
  });
  const url = `${process.env.REACT_APP_IBL_DM_URL}/api/search/catalog/?${queryParam}`;
  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + localStorage.getItem('dm_token'),
    },
  })
    .then((resp) => {
      resp.json().then((response) => {
        callback(response);
      });
    })
    .catch(() => {
      callback({ results: [] });
    });
}

export function getCourseGradingPolicy(courseID, callback) {
  const baseURL = process.env.REACT_APP_IBL_LMS_URL;
  const url = `${
    baseURL.endsWith('/') ? baseURL : baseURL + '/'
  }api/grades/v1/policy/courses/${courseID}`;
  //const url = `${process.env.REACT_APP_IBL_STUDIO_URL}/grades/v1/policy/courses/?${courseID}`;
  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      credentials: 'include',
      //Authorization: 'Token ' + localStorage.getItem('dm_token'),
    },
  })
    .then((resp) => {
      resp.json().then((response) => {
        callback(response);
      });
    })
    .catch(() => {
      callback(null);
    });
}

export function getSkills(
  callback,
  page = 1,
  selectedFacets,
  context,
  limit = 12
) {
  /*const index = { _index: 'ibl-dm.public.dl_catalog_app_skill' };

  const data = `?filter=${JSON.stringify(index)}&page=${page}${context ? '&context=' + context : ''}`;

  orgSearch(data, (response) => {
    callback(response);
  });*/
  //Search Endpoint updated
  const queryParam = new URLSearchParams({
    content: 'skills',
    limit,
    ...(page > 1
      ? {
          offset: (page - 1) * limit,
        }
      : {}),
    ...(context
      ? {
          query: context,
        }
      : {}),
  });
  const url = `${process.env.REACT_APP_IBL_DM_URL}/api/search/catalog/?${queryParam}`;
  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + localStorage.getItem('dm_token'),
    },
  })
    .then((resp) => {
      resp.json().then((response) => {
        callback(response);
      });
    })
    .catch(() => {
      callback({ results: [] });
    });
}

export const saveRoleOrSkills = (data, callback, target = 'roles') => {
  const url =
    process.env.REACT_APP_IBL_DM_URL + `/api/catalog/${target}/public/`;
  fetch(url, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + localStorage.getItem('dm_token'),
    },
  })
    .then((resp) => {
      callback(resp.status);
    })
    .catch((err) => {
      //
    });
};

export function slugify(string) {
  return string
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function isMobile(targetSize = 786) {
  return window.innerHeight < targetSize;
}

/**
 * Filters out specified facets filters from an overall facets list.
 *
 * @param {Object} obj - The input object to be filtered.
 * @param {Array<string>} keysToFilter - An array of keys to exclude from the input object.
 * @returns {Object} A new object with the specified keys removed.
 *
 * @example
 * const data = {
 *   key1: "value1",
 *   key2: "value2",
 *   key3: "value3"
 * };
 * const keysToFilter = ["key2"];
 * const result = filterKeys(data, keysToFilter);
 * console.log(result);
 * // Output: { key1: "value1", key3: "value3" }
 */
export function filterFacetsKeys(obj, keysToFilter) {
  // Create a new object by copying the original
  const filteredObj = {};

  // Iterate through the object's keys
  for (const key in obj) {
    // Only copy the key if it's not in the keysToFilter array
    if (!keysToFilter.includes(key)) {
      filteredObj[key] = obj[key];
    }
  }

  return filteredObj;
}


export const getSkillsToursSteps = (setSteps, navigate) => {
  return [
    {
      selector: '.tour-tooltip-step-1',
      content: 'Quickly access an overview of your engagement, recently earned skills, credentials, and active courses.',
      position:"bottom",
      padding:{
        mask: [10, 5, -18, 5],
      },
      customAction:()=>{
        setSteps([])
        navigate('/profile/activity')
      }
    },
    {
      selector: '.tour-tooltip-step-2',
      content: 'Track your course engagement and activity history. View time spent, recent interactions, and overall learning progress.',
      position:"bottom",
      customAction:()=>{
        setSteps([])
        navigate('/profile/skills')
      }
    },

    {
      selector: '.tour-tooltip-step-3',
      content: "View and manage your earned, self-reported, and desired skills. Use this section to highlight competencies you've developed or aim to acquire.",
      position:"bottom",
      customAction:()=>{
        setSteps([])
        navigate('/profile/credentials')
      }
    },
    {
      selector: '.tour-tooltip-step-6',
      content: "Access all credentials you've earned by completing courses or programs. Showcase your achievements by downloading or sharing your certificates.",
      position:"bottom",
      customAction:()=>{
        setSteps([])
        navigate('/profile/pathways')
      }
    },
    {
      selector: '.tour-tooltip-step-4',
      content: 'Create and enroll in custom learning pathways to achieve your specific goals. Pathways bundle courses and resources for a structured learning journey.',
      position:"bottom",
      customAction:()=>{
        setSteps([])
        navigate('/profile/programs')
      }
    },
    {
      selector: '.tour-tooltip-step-5',
      content: 'Explore programs curated by administrators to provide comprehensive learning experiences. Enroll to progress through multiple courses under a unified theme.',
      position:"bottom",
      customAction:()=>{
        setSteps([])
        navigate('/discover')
      }
    },



    {
      selector: '.tour-tooltip-step-7',
      content: "Browse a catalog of available courses and programs. Use filters to find content that aligns with your learning goals and enroll in topics of interest.",
      position:"bottom",
      padding:{
        mask: [10, 5, -18, 5],
      },
      customAction:()=>{
        setSteps([])
      }
    },

  ]
}